module.exports = __webpack_public_path__ + "img/roguesport20.b2de2e14.png";